import Vue from 'vue'
import VueRouter from 'vue-router'
import IndexPage from './index'
import IndexSpPage from './index.sp'
import pcPages from './pages/pc'
import spPages from './pages/sp'

Vue.use(VueRouter)

const routes = [
  { path: '/', component: IndexPage, name: 'index' },
  { path: '/concept', component: pcPages.Concept, name: 'concept' },
  { path: '/business', component: pcPages.Business, name: 'business' },
  { path: '/company', component: pcPages.Company, name: 'company' },
  { path: '/contact', component: pcPages.Contact, name: 'contact' },
  { path: '/sp', component: IndexSpPage, name: 'sp' },
  { path: '/sp/concept', component: spPages.Concept, name: 'sp-concept' },
  {
    path: '/sp/concept/text',
    component: spPages.ConceptText,
    name: 'sp-concept-text'
  },
  { path: '/sp/business', component: spPages.Business, name: 'sp-business' },
  {
    path: '/sp/business/text',
    component: spPages.BusinessText,
    name: 'sp-business-text'
  },
  { path: '/sp/company', component: spPages.Company, name: 'sp-company' },
  {
    path: '/sp/company/text',
    component: spPages.CompanyText,
    name: 'sp-company-text'
  },
  { path: '/sp/contact', component: spPages.Contact, name: 'sp-contact' }
]

export default new VueRouter({
  routes
})
